import { useEffect } from "react";
import { View, Div, Spacer } from "@base-ui";
import { ControlPanel } from "@interdependence-ui";
import { Footer, initializeCookieWarning } from "@domain-ui";
import { DialogAligner } from "../dialogAligner/DialogAligner";
import { useNotificationContext } from "@notifications/context";
import { ErrorBanner } from "@notifications/errorNotifications";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ControlPanelPage = function ControlPanelPage(_ref) {
  var id = _ref.id,
    title = _ref.title,
    controlpanel = _ref.controlpanel,
    view = _ref.view,
    _collapsed = _ref._collapsed;
  var _useNotificationConte = useNotificationContext(),
    notification = _useNotificationConte.notification,
    showNotification = _useNotificationConte.showNotification;
  var height = showNotification && notification !== null && notification !== void 0 && notification.text ? "calc(100vh - 104px)" : "";
  useEffect(function () {
    initializeCookieWarning();
  }, []);
  return /*#__PURE__*/_jsxs(View, {
    maxHeight: true,
    height: height,
    className: "controlpanel-page-container",
    children: [/*#__PURE__*/_jsx(ControlPanel, {
      className: "hide-while-printing",
      title: title,
      id: id,
      _collapsed: _collapsed,
      children: controlpanel
    }), /*#__PURE__*/_jsxs(Spacer, {
      id: "main-scroll-el",
      p: "sm",
      controlPanelPage: true,
      position: "relative",
      children: [/*#__PURE__*/_jsx(ErrorBanner, {
        m: "-20px -20px 0px",
        top: "-20px",
        width: "calc(100% + 40px)"
      }), /*#__PURE__*/_jsx(Div, {
        as: "main",
        m: "auto auto 20px",
        maxWidth: "1600px",
        children: view
      }), /*#__PURE__*/_jsx(Footer, {})]
    }), /*#__PURE__*/_jsx(DialogAligner, {})]
  });
};